import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=5582742f&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"
import style0 from "./recruit.vue?vue&type=style&index=0&id=5582742f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582742f",
  null
  
)

export default component.exports